import AdminsScreen from "../modules/users/AdminsScreen";

export default function Admin() {
  return (
    <>
      <AdminsScreen />
    </>
  )
}
